/*
 * create by nguyendx 2017/10/05
 */
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {BrowserModule} from '@angular/platform-browser';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {
  ConfirmDialogModule,
  GrowlModule,
  TooltipModule,
} from 'primeng/primeng';
import {HelperModule} from '../../../../common/helper/helper.module';
import {UploadService} from '../../../../common/services/Upload.service';
import {FlashMessagesModule} from 'angular2-flash-messages';
import {FindStampMbBySerialComponent} from './find-stamp-mb-by-serial.component';
import {StampBoxMbComponent} from './stamp-box-mb/stamp-box-mb.component';
import {StampProductMbComponent} from './stamp-product-mb/stamp-product-mb.component';
import {HistoryBoxModule} from '../../qrcode/history-box/history-box.module';
import {AgmCoreModule} from '@agm/core';
import {AgmDirectionModule} from 'agm-direction';
import {BsDatepickerModule} from 'ngx-bootstrap';
import {ModalModule} from 'ngx-bootstrap/modal';
import {TypeaheadModule} from 'ngx-bootstrap/typeahead';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ConfirmDialogModule,
    GrowlModule,
    TooltipModule,
    BrowserModule,
    HelperModule,
    FlashMessagesModule,
    HistoryBoxModule,
    AgmCoreModule,
    AgmDirectionModule,
    BsDatepickerModule,
    ModalModule,
    TypeaheadModule,
  ],
  declarations: [
    FindStampMbBySerialComponent,
    StampBoxMbComponent,

    StampProductMbComponent,
  ],
  exports: [
    FindStampMbBySerialComponent,
    StampBoxMbComponent,
    StampProductMbComponent,
  ],
  providers: [UploadService],
})
export class StampListMbModule {
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/stamp_list_mb/stamp-mb.module.ts